import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const RefundPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom>
        Política de Devoluciones
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          1. Condiciones Generales
        </Typography>
        <Typography paragraph>
          Debido a la naturaleza digital de nuestros productos, las devoluciones están sujetas a condiciones específicas. Las licencias activadas no son elegibles para devolución.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          2. Elegibilidad para Devoluciones
        </Typography>
        <ul className="list-disc pl-6 space-y-2">
          <li>Licencias no activadas dentro de las 24 horas posteriores a la compra</li>
          <li>Productos que presenten problemas técnicos verificables</li>
          <li>Compras realizadas por error (antes de la activación)</li>
        </ul>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          3. Proceso de Devolución
        </Typography>
        <Typography paragraph>
          Para solicitar una devolución:
        </Typography>
        <ol className="list-decimal pl-6 space-y-2">
          <li>Contacte con nuestro servicio de atención al cliente</li>
          <li>Proporcione el número de pedido y motivo de la devolución</li>
          <li>Espere la confirmación de elegibilidad</li>
          <li>Siga las instrucciones proporcionadas para el reembolso</li>
        </ol>
      </Box>

      <Box>
        <Typography variant="h5" gutterBottom>
          4. Reembolsos
        </Typography>
        <Typography paragraph>
          Los reembolsos aprobados se procesarán en un plazo de 5-10 días hábiles utilizando el mismo método de pago original de la compra.
        </Typography>
      </Box>
    </Container>
  );
};

export default RefundPolicy;